export const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const formatBalance = (balance: number, decimals: number = 6): string => {
  return balance.toFixed(decimals);
};

export const formatAddress = (address: string): string => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const isValidPrivateKey = (privateKey: string): boolean => {
  // Проверяем что это валидный приватный ключ (64 символа hex или с префиксом 0x)
  const cleanKey = privateKey.replace('0x', '');
  return /^[a-fA-F0-9]{64}$/.test(cleanKey);
};

export const isValidAddress = (address: string): boolean => {
  // Проверяем что это валидный Ethereum адрес
  return /^0x[a-fA-F0-9]{40}$/.test(address);
};

export const sleep = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

// Известные токены на Base
const BASE_TOKENS: Record<string, string> = {
  '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee': 'ETH',
  '0x4200000000000000000000000000000000000006': 'WETH',
  '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913': 'USDC',
  '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca': 'USDbC',
  '0x50c5725949a6f0c72e6c4a641f24049a917db0cb': 'DAI',
  '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22': 'cbETH',
};

export const getTokenSymbol = (address: string | undefined): string => {
  if (!address) return 'TOKEN';
  const normalizedAddress = address.toLowerCase();
  return BASE_TOKENS[normalizedAddress] || 'TOKEN';
};

export const isNativeETH = (address: string | undefined): boolean => {
  if (!address) return false;
  return address.toLowerCase() === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
};